import { render, staticRenderFns } from "./orderPageView.vue?vue&type=template&id=6ac57a1e&scoped=true&"
import script from "./orderPageView.vue?vue&type=script&lang=js&"
export * from "./orderPageView.vue?vue&type=script&lang=js&"
import style0 from "./orderPageView.vue?vue&type=style&index=0&id=6ac57a1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac57a1e",
  null
  
)

export default component.exports